export { default as ArrowUpTriangleSolidIcon } from './ArrowUpTriangleSolidIcon';
